"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScenarioStatisticTarget;
(function (ScenarioStatisticTarget) {
    ScenarioStatisticTarget["collection"] = "collection";
    ScenarioStatisticTarget["single"] = "single";
})(ScenarioStatisticTarget = exports.ScenarioStatisticTarget || (exports.ScenarioStatisticTarget = {}));
//# sourceMappingURL=ScenarioStatisticTarget.js.map